import { useEffect, useState } from "react";

import {
  useNavigate,
  useParams,
  Link,
} from "react-router-dom";

import { useDispatch } from "react-redux";

import Footer from "../../../../components/Footer/Footer";

import SuccessIcon from "../../../../assets/icons/order-placed.gif";

import SuccessIconStatic from "../../../../assets/icons/Success-Icon.png";

import "../styles/SuccessPage.css";

import { formatDate } from "../../../../utils/date.utils";

import AddonItems from "../components/AddonItems";

import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";

import { fetchAddOns } from "../../../Products/topPicks/redux/topPicksSlice";

import { useCartWishlist } from "../../../../app/CartWishlistContext";

import { fetchPlacedOrder } from "../services/payment.service";

const Successpage = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { ref_id } = useParams();

  const { getCartWishlistCount } =
    useCartWishlist();

  const [showGif, setShowGif] =
    useState(true);

  const [loading, setLoading] =
    useState(true);

  const [orderData, setOrderData] =
    useState(null);

  /**
   * =========================
   * FETCH ORDER
   * =========================
   */
  const getOrder = async () => {

    try {

      setLoading(true);

      const response =
        await fetchPlacedOrder(ref_id);

      //  Redirect if no data
      if (!response || !response.success || !response.data
      ) {

        navigate("/404", {
          replace: true,
        });

        return;
      }
      if (response && (response.data.order_no === "" || response.data.order_no === null || response.data.order_no === undefined)) {
        navigate("/404", {
          replace: true,
        });

        return;
      }


      setOrderData(response.data);

    } catch (error) {

      console.error(
        "[SuccessPage:getOrder]",
        error
      );

      //  Redirect on API failure
      navigate("/404", {
        replace: true,
      });

    } finally {

      setLoading(false);

    }
  };

  /**
   * =========================
   * INITIAL LOAD
   * =========================
   */
  useEffect(() => {

    document.title =
      "Obsessions - Order Placed";

    if (!ref_id) {

      navigate("/404", {
        replace: true,
      });

      return;
    }

    getOrder();

    dispatch(fetchAddOns());

    getCartWishlistCount();

    const timer = setTimeout(() => {
      setShowGif(false);
    }, 1000);

    return () => clearTimeout(timer);

  }, [ref_id]);

  /**
   * =========================
   * LOADING
   * =========================
   */
  if (loading) {

    return (
      <div className="py-5 text-center">
        <div
          className="spinner-border"
          role="status"
        />
      </div>
    );
  }

  /**
   * =========================
   * SAFETY RETURN
   * =========================
   */
  if (!orderData) return null;

  const orderNumber =
    orderData?.order_no || "--";

  const formattedDate =
    orderData?.created_at
      ? formatDate(orderData.created_at)
      : "--";

  return (
    <>
      <Breadcrumbs
        paths={[
          {
            label: "Order Placed",
          },
          {
            label: orderNumber,
            to: `/accounts/orders/${orderNumber}`,
          },
        ]}
      />

      <div className="success-container">

        <div className="mb-0">
          <img
            src={
              showGif
                ? SuccessIcon
                : SuccessIconStatic
            }
            alt="Payment Success"
            width={140}
          />
        </div>

        <h2 className="success-title">
          Order Placed Successfully
        </h2>

        <p className="success-subtitle">
          Thank you for shopping with us!
        </p>

        <div className="arrival-box">

          <p className="arrival-id">
            Order Placed:
            <span>
              {" "}
              {formattedDate}
            </span>
          </p>

          <p className="arrival-id-order">
            Order ID:
            <span>
              {" "}
              {orderNumber}
            </span>
          </p>

        </div>

        <div className="button-group">

          <Link
            to={`/accounts/orders/${orderNumber}`}
          >
            <button className="btn-outline">
              View Order
            </button>
          </Link>

          <button
            onClick={() => navigate("/")}
            className="btn-outline-continue"
          >
            Continue Shopping
          </button>

        </div>
      </div>

      <AddonItems />

      <Footer />
    </>
  );
};

export default Successpage;